import FeatureWithRating from './FeatureWithRating'

export default FeatureWithRating
